import aboutMobile from "../../../assets/images/about/mobile/image-about-hero.jpg";
import aboutTablet from "../../../assets/images/about/tablet/image-about-hero.jpg";
import aboutDesktop from "../../../assets/images/about/desktop/image-about-hero.jpg";
import talentMobile from "../../../assets/images/about/mobile/image-world-class-talent.jpg";
import talentTablet from "../../../assets/images/about/tablet/image-world-class-talent.jpg";
import talentDesktop from "../../../assets/images/about/desktop/image-world-class-talent.jpg";
import dealMobile from "../../../assets/images/about/mobile/image-real-deal.jpg";
import dealTablet from "../../../assets/images/about/tablet/image-real-deal.jpg";
import dealDesktop from "../../../assets/images/about/desktop/image-real-deal.jpg";

export const aboutData = {
  sectionOne: {
    header: "About Us",
    content: {
      p1: "At BitTech, we are more than just a software agency — we are architects of digital transformation. With a passion for innovation and a commitment to excellence, we specialize in crafting bespoke solutions that empower businesses to thrive in the ever-evolving digital landscape.",
    },
    image: {
      imgMobile: aboutMobile,
      imgTablet: aboutTablet,
      imgDesktop: aboutDesktop,
      imgAlt: "developers collaborating on a project",
    },
  },
  sectionTwo: {
    header: "Our Mission",
    content: {
      p1: "At the core of our mission is the relentless pursuit of technological advancement. We strive to be at the forefront of industry trends, harnessing the power of cutting-edge technologies to provide our clients with solutions that not only meet their current needs but also position them for future success.",
      p2: "From the elegant design and functionality of websites to the limitless possibilities of artificial intelligence and the robust reliability of network solutions, our multidisciplinary team of experts brings a wealth of experience to every project. We are your partners in bringing ideas to life, with a keen focus on delivering solutions that go beyond expectations.",
    },
    image: {
      imgMobile: talentMobile,
      imgTablet: talentTablet,
      imgDesktop: talentDesktop,
      imgAlt: "a lady looking at beautiful arts on the wall",
    },
  },
  sectionThree: {
    header: "Innovation That Matters",
    content: {
      p1: "Innovation is not just a buzzword for us; it's a way of life. We leverage the latest tools and methodologies to create solutions that drive efficiency, enhance user experiences, and propel your business forward. Our commitment to staying ahead of the curve ensures that you are always equipped with the most advanced and relevant technologies.",
      p2: "Your success is our success. We take a collaborative approach, working closely with our clients to understand their unique challenges and goals. Through open communication and a deep understanding of your business, we deliver tailor-made solutions that address your specific needs and aspirations.",
    },
    image: {
      imgMobile: dealMobile,
      imgTablet: dealTablet,
      imgDesktop: dealDesktop,
      imgAlt: "a lady pinning design ideas to the wall",
    },
  },
};
